import isAnalyticsEnabled from "@/utils/isAnalyticsEnabled.js";
import ReactGA from "react-ga4";

export default function reportEvent(obj) {
    if(isAnalyticsEnabled()) {
        ReactGA.event(obj);
    }
}